import * as React from 'react';
import { AdditionalResident } from '../../api/Prospect';
import Button from './form/Button';
import { RelationshipType } from '../../utilities/Enums';
import FormInput from './form/Input';
import FormPhoneInput from './form/PhoneInput';
import FormSelectLabeled from './form/SelectLabeled';
import '../../styles/AdditionalResidents.css';

interface Props {
    additionalResidents: AdditionalResident[];
    onResidentsChange: (additionalResidents: AdditionalResident[]) => void;
}

const AdditionalResidentsSection = (props: Props) => {
    const handleChange = (index: number, field: string, value: any) => {
        let additionalResidents = props.additionalResidents;
        let resident = additionalResidents[index];
        resident[field] = value;
        additionalResidents[index] = resident;
        props.onResidentsChange(additionalResidents);
    };

    return (
        <div className="additional-residents-section">
            <div className="row">
                <div className="col-9">
                    <label className="font-weight-bold">Additional Guests</label>
                    <p>Anyone touring must be added and agree to Terms of Use.</p>
                </div>
                <div className="col-3">
                    <Button
                        text="+ Add"
                        suppressBottomMargin={true}
                        disabled={props.additionalResidents.length >= 4}
                        onClick={() =>
                            props.onResidentsChange([
                                ...props.additionalResidents,
                                {
                                    firstName: '',
                                    lastName: '',
                                    relationshipType: RelationshipType.Roommate
                                }
                            ])
                        }
                    />
                </div>
            </div>

            {props.additionalResidents.map((resident, index) => (
                <div key={index} className="card additional-residents-card">
                    <i 
                        className="fa-solid fa-x addtional-residents-card-close"
                        onClick={() => {
                            let residents = props.additionalResidents;
                            residents.splice(index, 1);
                            props.onResidentsChange(residents);
                        }}
                        title="Close"
                    />                       
                    <div className="card-body container">
                        <div className="form-row form-group">
                            <FormInput
                                labelProps={{
                                    labelText: 'First Name',
                                    invalidText: 'Please enter a first name'
                                }}
                                inputProps={{
                                    value: resident.firstName,
                                    name: 'firstName',
                                    id: `first-name-${index}`,
                                    required: true,
                                    placeholder: 'John'
                                }}
                                onChange={(field, value) => handleChange(index, field, value)}
                                controlCssClass="col-12 col-md-6 row-input-group"
                            />
                            <FormInput
                                labelProps={{
                                    labelText: 'Last Name',
                                    invalidText: 'Please enter a last name'
                                }}
                                inputProps={{
                                    value: resident.lastName,
                                    name: 'lastName',
                                    id: `last-name-${index}`,
                                    required: true,
                                    placeholder: 'Doe'
                                }}
                                onChange={(field, value) => handleChange(index, field, value)}
                                controlCssClass="col-12 col-md-6 row-input-group"
                            />
                        </div>
                        <div className="form-row form-group">
                            <FormInput
                                labelProps={{
                                    labelText: 'Email',
                                    invalidText: 'Please enter an email address'
                                }}
                                inputProps={{
                                    value: resident.email || '',
                                    name: 'email',
                                    id: `email-${index}`,
                                    type: 'email',
                                    required: true,
                                    placeholder: 'myaddress@example.com'
                                }}
                                onChange={(field, value) => handleChange(index, field, value)}
                                controlCssClass="col-12 col-md-6 row-input-group"
                            />
                            <FormPhoneInput
                                labelProps={{
                                    labelText: 'Cell Number'
                                }}
                                inputProps={{
                                    value: resident.phone || '',
                                    name: 'phone',
                                    required: true,
                                    id: `phone-${index}`
                                }}
                                onChange={(field, value) => handleChange(index, field, value)}
                                controlCssClass="col-12 col-md-6 row-input-group"
                            />
                        </div>
                        <div className="form-row form-group">
                            <FormSelectLabeled
                                labelProps={{
                                    labelText: 'Relationship'
                                }}
                                selectProps={{
                                    id: `type-${index}`,
                                    name: 'relationshipType',
                                    value: resident.relationshipType,
                                    required: true
                                }}
                                selectOptions={[
                                    {
                                        label: 'Roommate',
                                        value: RelationshipType.Roommate
                                    },
                                    {
                                        label: 'Spouse',
                                        value: RelationshipType.Spouse
                                    },
                                    { label: 'Minor', value: RelationshipType.Minor },
                                    { label: 'Other Guest', value: RelationshipType.OtherGuest }
                                ]}
                                onChange={(field, value) => handleChange(index, field, value)}
                                className="col-12 col-md-6 row-input-group"
                            />
                            {/* <div className="col-12 col-md-6">
                                <button
                                    id={`delete-${index}`}
                                    className="btn btn-danger font-weight-bold"
                                    onClick={() => {
                                        let residents = props.additionalResidents;
                                        residents.splice(index, 1);
                                        props.onResidentsChange(residents);
                                    }}
                                    type="button"
                                >
                                    Remove
                                </button>
                            </div> */}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default AdditionalResidentsSection;



// WEBPACK FOOTER //
// ./src/components/common/AdditionalResidentsSection.tsx